import { SortTypes, SortDirections } from './TeacherSortMenu';

const compare = (a, b, type, direction) => {
  const d = direction === SortDirections.Desc ? 1 : -1;
  // ByStudentName
  if (
    type.id === SortTypes.ByStudentNameDown.id ||
    type.id === SortTypes.ByStudentNameUp.id
  ) {
    // 'a' comes first (d > 0)
    if (a.name < b.name) {
      return -1 * d;
    }
    // 'b' comes first
    if (a.name > b.name) {
      return 1 * d;
    }
  }
  // ByTimeSpent
  else if (
    type.id === SortTypes.ByTimeSpentDown.id ||
    type.id === SortTypes.ByTimeSpentUp.id
  ) {
    // 'a' comes first (d > 0)
    if (a.timeSpent < b.timeSpent) {
      return -1 * d;
    }
    // 'b' comes first
    if (a.timeSpent > b.timeSpent) {
      return 1 * d;
    }
  }
  // ByNumberOfTasksCompleted
  else if (
    type.id === SortTypes.ByNumberOfTasksCompletedDown.id ||
    type.id === SortTypes.ByNumberOfTasksCompletedUp.id
  ) {
    // 'a' comes first (d > 0)
    if (a.tasksCompleted < b.tasksCompleted) {
      return -1 * d;
    }
    // 'b' comes first
    if (a.tasksCompleted > b.tasksCompleted) {
      return 1 * d;
    }
  }
  // ByAccuracy
  else if (
    type.id === SortTypes.ByAccuracyDown.id ||
    type.id === SortTypes.ByAccuracyUp.id
  ) {
    // 'a' comes first (d > 0)
    if (a.exercisesPercent < b.exercisesPercent) {
      return -1 * d;
    }
    // 'b' comes first
    if (a.exercisesPercent > b.exercisesPercent) {
      return 1 * d;
    }
  }
  // ByNumberOfTasksStruggle
  else if (
    type.id === SortTypes.ByNumberOfTasksStruggleDown.id ||
    type.id === SortTypes.ByNumberOfTasksStruggleUp.id
  ) {
    // 'a' comes first (d > 0)
    if (a.struggleTasks < b.struggleTasks) {
      return -1 * d;
    }
    // 'b' comes first
    if (a.struggleTasks > b.struggleTasks) {
      return 1 * d;
    }
  }
  return 0;
};

export const useSort = (
  data,
  sortType = SortTypes.ByStudentNameDown,
  sortDirection = SortDirections.Desc
) => {
  if (!data) return data;
  const sortedData = JSON.parse(JSON.stringify(data));
  sortedData.groups.forEach((group) => {
    group.students.sort((a, b) => compare(a, b, sortType, sortDirection));
  });
  return sortedData;
};

export default {};
